import { useQuery } from "@tanstack/react-query";
import {
  LifecycleManagementAllEvents,
  LifecycleManagementClient,
} from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../../../auth/ApiClientConfig";
import { ASSET_LIFECYCLE_QUERY_KEYS } from "../constants";

const isNotFound = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  "status" in error &&
  (error as { status?: unknown }).status === 404;

/**
 * Looks up one lifecycle event by its unique identifier for a routed drawer deep link.
 * Resolves to `null` when the event does not exist (404); other failures stay errors.
 */
export function useGetLifecycleEventByIdentifier(
  uniqueIdentifier: string | undefined,
) {
  return useQuery<LifecycleManagementAllEvents | null>({
    queryKey: [ASSET_LIFECYCLE_QUERY_KEYS.eventByIdentifier, uniqueIdentifier],
    queryFn: async () => {
      const api = new LifecycleManagementClient(
        ApiClientConfig,
        import.meta.env.API_ENDPOINT,
      );
      try {
        return (
          (await api.getEventByUniqueIdentifier(uniqueIdentifier ?? "")) ?? null
        );
      } catch (error) {
        if (isNotFound(error)) {
          return null;
        }
        throw error;
      }
    },
    enabled: uniqueIdentifier !== undefined,
  });
}
